export enum NumberLineSrcKeys {
  ARROW_UP_RED = 'bootcamp/arrow-up-red.png',
  ARROW_UP = 'bootcamp/arrow-up.png',
  ARROW_UP_BLUE = 'bootcamp/arrow-up-blue.png',
}
